export const FT_TO_METER = 0.3048;
export const METER_TO_FT = 1.0 / FT_TO_METER;
